import { createAction } from '@reduxjs/toolkit';

import { FastCheckoutResetAction, FastCheckoutUpdateAction, IBuySubscription } from './fastCheckout.types';

const reset = createAction<FastCheckoutResetAction>('fastCheckout/reset');
const update = createAction<FastCheckoutUpdateAction>('fastCheckout/update');
const buySubscription = createAction<IBuySubscription>('fastCheckout/buySubscription');

export const FastCheckoutActions = {
    buySubscription,
    reset,
    update,
};
